import React, { useMemo, useState } from 'react';

import { hash } from '../../utils/hashGenerator';
import { CheckboxContainer, Cbx, LabelWrapper } from './styles';

interface CheckBoxProps extends React.InputHTMLAttributes<HTMLInputElement> {
  id?: string;
  label: string;
  value: string;
  disabled?: boolean;
}

export const Checkbox: React.FC<CheckBoxProps> = ({
  id = 'cbx',
  label,
  value,
  disabled,
  onChange = () => {},
  readOnly,
  checked,
  name,
}) => {
  const [internalCheck, setInternalCheck] = useState(false);

  let i = 0;

  // eslint-disable-next-line react-hooks/exhaustive-deps
  function generateCheckboxName(): string {
    return hash((i = i + 1));
  }

  const internalName = useMemo(() => name || generateCheckboxName(), [
    generateCheckboxName,
    name,
  ]);

  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement>,
  ): boolean | void => {
    if (disabled || readOnly) {
      e.preventDefault();
      e.stopPropagation();

      return false;
    }

    e.persist();

    setInternalCheck(!internalCheck);

    onChange && onChange(e);
  };

  return (
    <CheckboxContainer>
      <LabelWrapper
        control={
          <Cbx
            id={hash(id)}
            name={internalName}
            value={value}
            disabled={disabled}
            readOnly={readOnly}
            onChange={handleChange}
            tabIndex={disabled || readOnly ? -1 : 0}
            aria-checked={checked !== undefined ? checked : internalCheck}
            aria-readonly={readOnly ? 'true' : 'false'}
            aria-disabled={disabled ? 'true' : 'false'}
          />
        }
        label={label ? label : 'Label do Checkbox'}
      />
    </CheckboxContainer>
  );
};
